var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:[
    'family-item',
    {
      selected: _vm.selected,
      disabled: _vm.disabled,
    },
  ],on:{"click":function($event){return _vm.$emit('click')}}},[_c('div',{staticClass:"image-container"},[_c('picture',[(_vm.item.main_image)?_c('img',{staticClass:"image",attrs:{"src":_vm.image,"alt":_vm.item.name,"loading":"lazy"}}):_vm._e()])]),_c('article',{staticClass:"family-item-content"},[_c('div',{staticClass:"family-item-title"},[_vm._v(" "+_vm._s(_vm.item.name)+" ")]),_c('div',{staticClass:"price body-s-regular"},[(_vm.item.min_price)?_c('span',[_vm._v(" เริ่มต้น ฿"+_vm._s(_vm._f("currency")(_vm.item.min_price)))]):_c('span',[_vm._v(" ")])])])])
}
var staticRenderFns = []

export { render, staticRenderFns }